import React from "react";

// Legacy Sidebar is now a no-op because AppShell (via PrivateRoute) provides
// the left-side navigation for all authenticated pages.
// Kept as a named export so existing `import Sidebar from "..."` doesn't crash.
const Sidebar = () => null;

export default Sidebar;
